// Downward chevron used as the FAQ accordion's open/closed affordance.
// Decorative — the disclosure button carries the question text as its visible
// label and `aria-expanded` carries the state, so the chevron is aria-hidden.
// Size via CSS font-size (renders at 1em); color via currentColor.
export function ChevronDownIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(className ? { className } : {})}
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}
